import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, ArrowRight, ExternalLink } from 'lucide-react';

const FloatingShopButton = () => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 100 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="fixed right-6 bottom-24 z-40"
      >
        <a
          href="https://www.taktikstore.com"
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center gap-3 px-5 py-3 bg-vav-gold hover:bg-vav-gold/90 text-black rounded-full shadow-lg transition-all duration-300 hover:shadow-[0_0_30px_rgba(196,168,75,0.4)]"
          data-testid="floating-shop-btn"
        >
          <ShoppingBag className="w-5 h-5" />
          <span className="font-heading text-sm uppercase tracking-wider">Alışveriş</span>
          <motion.div
            animate={{ x: [0, 5, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
          >
            <ExternalLink className="w-4 h-4" />
          </motion.div>
        </a>
        
        {/* Pulse effect */}
        <motion.div
          className="absolute inset-0 bg-vav-gold rounded-full -z-10"
          animate={{ scale: [1, 1.2, 1], opacity: [0.5, 0, 0.5] }}
          transition={{ repeat: Infinity, duration: 2 }}
        />
      </motion.div>
    </AnimatePresence>
  );
};

export default FloatingShopButton;
